import { useState, useEffect, useMemo } from 'react';
import { Button, Spinner } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { downloadIncidentPDF, getIncidentReportById } from './FormikHelpers/Api';

export const DownloadIncidentReportPDFButton = ({ reportId, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [error, setError] = useState(null);

  const userTimezone = useMemo(() => 
    Intl.DateTimeFormat().resolvedOptions().timeZone, 
  []);

  useEffect(() => {
    if (!reportId) return;

    const fetchMetadata = async () => {
      try {
        await getIncidentReportById(reportId);
        setDataLoaded(true);
      } catch (err) {
        setError('Failed to load report');
      }
    };

    fetchMetadata();
  }, [reportId]);

  const handleDownload = async () => {
    if (!reportId) return;
    setLoading(true);
    await downloadIncidentPDF(reportId, userTimezone);
    setLoading(false);
  };

  if (error || !reportId) {
    return (
      <Button color="danger" disabled>
        Cannot generate PDF
      </Button>
    );
  }

  return (
    <Button
      color="success"
      onClick={handleDownload}
      disabled={disabled || loading || !dataLoaded}
      className="d-flex align-items-center"
    >
      {loading ? (
        <>
          <Spinner size="sm" className="me-2" />
          Downloading PDF...
        </>
      ) : (
        <>
          <FeatherIcon icon="download" size={16} className="me-2" />
          Download PDF Report
        </>
      )}
    </Button>
  );
};